import ListSessionExams from "./List/List";
import { SESSION_EXAMS, StudentServicePath } from "utils/constants";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import permissions from "app/permissions";
import CreateSessionExam from "./Create/Create";
import ShowSessionExam from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <HistoryEduIcon />,
  name: StudentServicePath + SESSION_EXAMS,
  title: "Изпити",
  list: <ListSessionExams />,
  create: <CreateSessionExam />,
  createPermission: permissions.canCreateSessionExams,
  // TODO
  // edit:
  // editPermission:
  show: <ShowSessionExam />,
  showPermission: permissions.canPreviewSessionExams,
  permission: permissions.canPreviewSessionExams,
};
